module.exports = __webpack_public_path__ + "static/img/Round-22-2012.9370bb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-22-2012.jpg
// module id = CCIB
// module chunks = 0